import React from "react";
import ReactHtmlParser from "react-html-parser";
import HempBanSectionHead from "@herb/components/HempBan/HempBanSectionHead";
import "./index.css";

/**
 * Key Dates — a connector timeline driven by `dates[]` followed by the
 * deadline cards. `status` marks the active point (filled lime dot); every
 * other point renders the dashed outline dot.
 */
const HempBanKeyDates = ({ keyDatesSection }) => {
  if (!keyDatesSection) {
    return null;
  }

  const { badgeText, heading, dates = [], cards = [] } = keyDatesSection;
  const points = (dates || []).filter(Boolean);

  return (
    <section className="hb-section hb-key-dates" id="hemp-ban-key-dates">
      <div className="hb-container">
        <HempBanSectionHead badgeText={badgeText} heading={heading} />

        {points.length ? (
          <ol className="hb-timeline">
            {points.map((point, index) => (
              <li
                className={`hb-timeline-point${
                  point.status ? " hb-timeline-point--active" : ""
                }`}
                key={`${point.heading || "point"}-${index}`}
              >
                <span className="hb-timeline-dot" aria-hidden="true" />
                {point.heading ? (
                  <span className="hb-timeline-label">{point.heading}</span>
                ) : null}
                {point.subheading ? (
                  <span className="hb-timeline-date">{point.subheading}</span>
                ) : null}
              </li>
            ))}
          </ol>
        ) : null}

        {cards && cards.length ? (
          <div className="hb-dates-grid">
            {cards.map((card, index) => (
              <article
                className="hb-date-card"
                key={`${card.heading || "card"}-${index}`}
              >
                {card.badgeText ? (
                  <span
                    className={`hb-date-tag hb-date-tag--${card.badgeStyle ||
                      "white"}`}
                  >
                    {card.badgeText}
                  </span>
                ) : null}
                {card.heading ? (
                  <h3 className="hb-date-heading">{card.heading}</h3>
                ) : null}
                {card.subheading ? (
                  <p className="hb-date-label">{card.subheading}</p>
                ) : null}
                {card.text ? (
                  <div className="hb-date-text hb-rich">
                    {ReactHtmlParser(card.text)}
                  </div>
                ) : null}
                {card.footerText ? (
                  <p className="hb-date-note">{card.footerText}</p>
                ) : null}
              </article>
            ))}
          </div>
        ) : null}
      </div>
    </section>
  );
};

export default HempBanKeyDates;
